//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var topImg = {
  0: 'https://p0.pipi.cn/rock/prod/common/image/8052dcec9f31291e9722472ea26de9a5.png?imageMogr2/thumbnail/2500x2500%3E',
  1: 'https://p0.pipi.cn/rock/prod/common/image/39d5df43ee417b891a81f1dcb3ccc4f4.png?imageMogr2/thumbnail/2500x2500%3E',
  2: 'https://p0.pipi.cn/rock/prod/common/image/1aea69d74fe3e00b07d9e390b824b371.png?imageMogr2/thumbnail/2500x2500%3E'
};
import Star from '../star/Star.vue';
import { getStar } from '@/utils/getStar';
import { parseDetailUrl } from "@/utils";
export default {
  name: 'top-item',
  components: {
    Star: Star
    // RankNumber,
  },

  props: {
    isHot: {
      type: Boolean,
      default: false
    },
    isGood: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      topImg: topImg,
      hopeNums: 0
    };
  },
  created: function created() {},
  methods: {
    getStarNum: getStar,
    gotoDetail: function gotoDetail(item) {
      var performanceId = item.performanceId,
        _item$jumpDetailUrl = item.jumpDetailUrl,
        jumpDetailUrl = _item$jumpDetailUrl === void 0 ? "" : _item$jumpDetailUrl;
      if (!performanceId) return;
      window.seedAction({
        bid: 'b_movie_85d7bokp_mc',
        viewBid: 'b_movie_85d7bokp_mv',
        performance_id: performanceId
      });
      if (jumpDetailUrl) {
        this.go(parseDetailUrl(jumpDetailUrl));
      } else {
        this.go("/detail/".concat(performanceId));
      }
      // this.go(`/detail/${performanceId}`);
    },

    goTop: function goTop() {
      var dataSeed = this.content.dataSeed;
      if (dataSeed) {
        window.seedAction(dataSeed);
      }
      // 好评1， 热度3
      this.go("/topList?billBoardAttrType=".concat(this.isGood ? 1 : 3), {
        _blank: true
      });
    }
  }
};